<ion-item *ngIf="isShow" class="ion-no-margin" lines="none">
    <ion-text>
        <h3 class="ion-text-center">{{ text }}</h3>
    </ion-text>
</ion-item>
